import React, { useState, useEffect, useRef } from 'react';
import { fetchSheetData } from '../api/getSheet';
import { useDispatch, useSelector } from 'react-redux';
import { triggerApiFetch, fetchWishesSuccess, fetchWishesFailure } from '../redux/actions/wishesActions';
import './WishingWall.less';

const WishingWall = () => {
  const [wishes, setWishes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const dispatch = useDispatch();
  const { shouldCallFetchWish } = useSelector((state) => state.wishes);

  useEffect(() => {
    const loadData = async () => {
      dispatch(triggerApiFetch());
      try {
        const sheetData = await fetchSheetData();
        const headers = sheetData[0];
        
        const nameIndex = headers.indexOf("如何稱呼");
        const wishIndex = headers.indexOf("許願功能");
        const extractedData = sheetData.slice(1).map(row => ({
          name: row[nameIndex],
          wish: row[wishIndex]
        })).reverse();
        dispatch(fetchWishesSuccess());
        setWishes(extractedData);
      } catch (error) {
        dispatch(fetchWishesFailure(error));
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    if (shouldCallFetchWish) {
      loadData();
    }
  }, [shouldCallFetchWish, dispatch]);

  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      const container = containerRef.current;
      const items = container.querySelectorAll('.wish-item');
      const newPositions = [];
      const MAX_RETRIES = 5;
      
      items.forEach((item) => {
        let x, y;
        let overlaps;
        let retries = 0;

        do {
          overlaps = false;
          x = Math.random() * (container.clientWidth - item.offsetWidth);
          y = Math.random() * (container.clientHeight - item.offsetHeight);

          // Check for overlap with existing items
          for (const pos of newPositions) {
            if (
              x < pos.x + pos.width &&
              x + item.offsetWidth > pos.x &&
              y < pos.y + pos.height &&
              y + item.offsetHeight > pos.y
            ) {
              overlaps = true;
              break;
            }
          }
          retries++;
          if (retries > MAX_RETRIES) {
            console.warn('Reached maximum retries, unable to place item without overlap.');
            break;
          }
        } while (overlaps);

        newPositions.push({ x, y, width: item.offsetWidth, height: item.offsetHeight });
        item.style.transform = `translate(${x}px, ${y}px)`;
      });

    }
  }, [wishes]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="wishing-wall-wrap">
      <div className="title">許願牆</div>
      <div className="wishing-wall">
      <div className="wishing-wall-inner" ref={containerRef}>
        {wishes.map((wish, index) => (
          wish.wish && (
          <div key={index} className="wish-item">
            <div className="wish-header">
              <div className="circle red"></div>
              <div className="circle yellow"></div>
              <div className="circle green"></div>
              <div className="wish-title">{wish.name}想說:</div>
            </div>
            <div className="wish-body">
              {wish.wish}
            </div>
          </div>)
        ))}
      </div>
    </div>
  </div>
  );
};

export default WishingWall;
